module.exports = __webpack_public_path__ + "static/media/HCMM650.4247477a.jpg";